import { Component, OnInit } from '@angular/core';
import { UserService } from 'src/app/services/http/user/user.service';


@Component({
  selector: 'app-extraction',
  templateUrl: './extraction.component.html',
  styleUrls: ['./extraction.component.scss']
})
export class ExtractionComponent implements OnInit {

  public forAdmin!: boolean;

  constructor(
    private userService: UserService
  ) { }

  ngOnInit(): void {
    this.forAdmin = localStorage.getItem('isAdmin')=='true';
    // console.log(this.forAdmin)

  }

}
